module.exports = __webpack_public_path__ + "linea-ecommerce-10.e8892174d7f87530f38e.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/linea-icons/fonts/linea-ecommerce-10.ttf
// module id = ../../../../../theme/scss/icons/linea-icons/fonts/linea-ecommerce-10.ttf
// module chunks = styles